module.exports = __webpack_public_path__ + "static/media/gensuite-conference.da397b6b.png";